/**
 * Toggle show/hide card full content
 * 
 * @param {string} selector 
 * @returns 
 */
const toggleCollapse = (selector) => {
  if ( ! selector ) return false

  let buttons = selector.getElementsByClassName('bttn-toggle')

  Array.prototype.filter.call(buttons, button => {
    button.addEventListener( 'click', (e) => {
      e.preventDefault();

      if ( 'show' === button.dataset.toggle ) {
        selector.classList.remove('collapsed')
        selector.parentNode.scrollTo({
          top: selector.offsetTop - 80,
          left: 0,
          behavior: 'smooth'
        })
      }
      if ( 'hide' === button.dataset.toggle ) selector.classList.add('collapsed')
    })
  })
}

/**
 * Set scroll-top position for element
 * 
 * @param {string} selector 
 * @returns void
 */
const setScrollTop = (selector) => {
  let wrapper = document.getElementsByClassName(selector);

  if (!wrapper) return false;

  Array.prototype.filter.call(wrapper, element => {
    element.addEventListener('scroll', (e) => {
      setTimeout(() => e.target.style.setProperty('--scroll-top', e.target.scrollTop), 0);
    });
  })

}

/**
 * Set ofsset-top value for elements
 * 
 * @param {string} selector 
 * @returns void
 */
const setOffsetTop = (selector) => {
  let wrapper = document.getElementsByClassName(selector);

  if (!wrapper) return false;

  Array.prototype.filter.call(wrapper, element => {
    element.style.setProperty('--offset-top', element.offsetTop);

    toggleCollapse(element);
  });

}

/**
 * Run scripts after DOM is loaded
 */
document.addEventListener('DOMContentLoaded', () => {
  setScrollTop('scroll-list-wrapper')
  setOffsetTop('scroll-list-item')
})
